import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { JaneDoeBusinessCardStackContentViewModel } from './jane-doe-business-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-jane-doe-card-stack-content',
  templateUrl: './jane-doe-business-card-stack-content.component.html',
  styleUrls: ['./jane-doe-business-card-stack-content.component.scss'],
  providers: [JaneDoeBusinessCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JaneDoeBusinessCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: JaneDoeBusinessCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
